// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"5416185cbae6bf0c12ff","293":"b1c2e3c6f92caa2350f8","518":"42763f5ee8dee896faa9","779":"1ac519426d6948f2df49"}[chunkId] + ".js";
};